import { ApiProperty } from "@nestjs/swagger";

export class EmployeeDto {

    @ApiProperty()
    id: number
    
    @ApiProperty()
    employeeName: string;

    @ApiProperty()
    departmentName: number;

    @ApiProperty()
    division: number;
    
    @ApiProperty()
    unit: string;

    @ApiProperty()
    role: number;

    @ApiProperty()
    refNo: string;
    // @ApiProperty()
    // from: string;

    // @ApiProperty()
    // to: string;

    // @ApiProperty()
    // noofpeople: string;

    @ApiProperty()
    contactNumber: string;

    @ApiProperty()
    address: string;

    @ApiProperty()
    gpsLocation: string;

    @ApiProperty()
    isActive: boolean;

    @ApiProperty()
    createdUser: string | null;


    @ApiProperty()
    updatedUser: string | null;

    // @ApiProperty()
    // createdAt: Date;

    // @ApiProperty()
    // updatedAt: Date;

    @ApiProperty()
    versionFlag: number;




}